export const COMPLETE_ITEM = 'bundles/COMPLETE_ITEM'
export const UNCOMPLETE_ITEM = 'bundles/UNCOMPLETE_ITEM'
